const normalize = (value) => String(value || "").trim().toLowerCase();

export function isDealerVehicle(vehicle) {
  return (
    normalize(vehicle?.sellerType) === "dealer" ||
    normalize(vehicle?.seller?.type) === "dealer" ||
    normalize(vehicle?.source) === "haendlermarkt" ||
    normalize(vehicle?.workflow?.type) === "dealer-auction"
  );
}

export function isOwnDealerVehicle(vehicle, dealerEmail) {
  const normalizedDealerEmail = normalize(dealerEmail);
  if (!normalizedDealerEmail || !isDealerVehicle(vehicle)) return false;

  return [
    vehicle?.dealerId,
    vehicle?.dealerEmail,
    vehicle?.email,
    vehicle?.seller?.auctionUserId,
    vehicle?.seller?.email,
  ]
    .map(normalize)
    .filter(Boolean)
    .includes(normalizedDealerEmail);
}
